import { useState, useEffect } from 'react';
import { Modal, Spinner, Button } from 'react-bootstrap';
import { InformationModal, StartStrategyModal } from 'Components/Common/Modal';
import { useParams, useHistory } from 'react-router-dom';
import { AutomatedStrategies, CopyTranding } from 'Services';
import { useSelector } from 'react-redux';
import { URL_PROFILE } from 'Helpers/urls';

export default ({
  brokerPortfolios,
  selectedBroker,
  onHide,
  isPortfolioLoading,
  handleConnectPortfolio,
  pageType,
  strategyName,
  price,
  handlePortfolioSelect,
  portfolioUserId,
  ...props
}) => {
  const { id } = useParams();
  const history = useHistory();
  const user = useSelector((state) => state.auth.user);

  const [subscriptionDetails, setSubscriptionDetails] = useState({});

  useEffect(() => {
    const getSubscriptionDetails = async () => {
      try {
        if (pageType === 'portfolio') {
          setSubscriptionDetails(await CopyTranding.getSubscriptionDetails(id, user.id));
        } else {
          setSubscriptionDetails(await AutomatedStrategies.getSubscriptionDetails(user.id, id || '76165ee6-690e-4198-b867-2b9fd16fba2c'));
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (pageType !== 'hostPortfolio') getSubscriptionDetails();
  }, [user.id, id, pageType]);

  /*  eslint-disable consistent-return */
  const handleBrokerPortfolioSelect = async (selectedPortfolios) => {
    if (pageType === 'hostPortfolio') {
      onHide();
      return handlePortfolioSelect(selectedPortfolios.id);
    }

    const isPortfolio = pageType === 'portfolio';

    const title = isPortfolio ? 'Start portfolio' : 'Start Strategy';
    const result = await StartStrategyModal(title, price, strategyName);

    if (result.isConfirmed) {
      // Redirect on payment if dont have subscription to the strategy
      if (!subscriptionDetails) {
        onHide();
        if (isPortfolio) {
          history.push(
            `/portfolio/${id}/payment?broker-id=${selectedBroker?.id}&portfolio-id=${selectedPortfolios?.id}&portfolio-user-id=${portfolioUserId}`,
          );
        } else {
          history.push(
            `/strategy/${id || '76165ee6-690e-4198-b867-2b9fd16fba2c'}/payment?broker-id=${selectedBroker?.id}&portfolio-id=${
              selectedPortfolios?.id
            }`,
          );
        }
      } else {
        // Start strategy/portfolio if already subscription to the strategy/portfolio
        try {
          if (isPortfolio) {
            await CopyTranding.startTrading(selectedPortfolios?.id, {
              transactionId: subscriptionDetails.transaction_id,
              masterPortfolioId: id,
            });
          } else {
            await AutomatedStrategies.startStrategy(user.id, {
              transactionId: subscriptionDetails.transaction_id,
              strategyId: id || '76165ee6-690e-4198-b867-2b9fd16fba2c',
              brokerId: selectedBroker?.id,
              portfolioId: selectedPortfolios?.id,
            });
          }
          onHide();
          await InformationModal(isPortfolio ? 'Success' : 'Strategy has been started!');
          history.push(URL_PROFILE);
        } catch (error) {
          console.error('Error', error);
        }
      }
    }
  };

  return (
    <Modal {...props} size="md" centered className="brokers-list-modal" animation={false} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title />
      </Modal.Header>
      <Modal.Body>
        <img src={selectedBroker.avatar_url} alt="logo" className="logo" />
        {isPortfolioLoading ? (
          <div className="my-5 d-flex justify-content-center">
            <Spinner animation="border" />
          </div>
        ) : (
          <>
            <p className="color-white mt-3">Please select your Broker Portfolio</p>
            {brokerPortfolios.map((portfolio) => (
              <div className="box-wrapper" key={portfolio.id} onClick={() => handleBrokerPortfolioSelect(portfolio)} role="button" tabIndex={0}>
                <span className="name">{portfolio.label}</span>
              </div>
            ))}
            <div className="text-center mt-5">
              <Button onClick={handleConnectPortfolio}>Connect Another Portfolio</Button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};
